/** SPA serves PNGs from `public/assets/achievements/{key}.png`. */

const DIR = '/assets/achievements';
const EXT = '.png';

/**
 * Returns a public URL for the achievement icon, or null if the key is empty/invalid.
 * Key is the file base name only (e.g. `achievement-1`), no `.png`.
 */
export function achievementIconSrcFromKey(key: string | null | undefined): string | null {
  const k = sanitizeAchievementIconKey(key);
  if (!k) return null;
  const base = process.env.PUBLIC_URL || '';
  return `${base}${DIR}/${k}${EXT}`;
}

export function sanitizeAchievementIconKey(raw: string | null | undefined): string | null {
  if (!raw?.trim()) return null;
  let s = raw.trim();
  if (s.toLowerCase().endsWith('.png')) s = s.slice(0, -4).trim();
  if (!s || !/^[a-zA-Z0-9_-]+$/.test(s)) return null;
  return s;
}
